import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mixed: translate({ id: 'order.form.bulk.mixed' }),
    email: translate({ id: 'orders.edit.field.email' }),
    invalidEmail: translate({
      id: 'orders.edit.validation.email.invalid',
    }),
  }))

  return api
}
